import { useContext, useState, useEffect, useMemo } from "react";
import { AppContext } from "@iscr/xAppLib/context";
import exprms_model from "models/exprms_model";

// quiet: look up the assignment without it counting as an exposure - neither a Statsig exposure on
// lookup nor our impression from f(), which becomes a no-op.
export function useExperiment(id, { quiet = false } = {}) {
	const { exprms = {} } = useContext(AppContext);
	const [statsigReady, setStatsigReady] = useState(0);

	useEffect(() => {
		const onReady = () => setStatsigReady(n => n + 1);
		app.on(app.events.STATSIG_READY, onReady);
		return () => app.off(app.events.STATSIG_READY, onReady);
	}, []);

	return useMemo(() => {
		const data = exprms_model.resolve(id, exprms, { quiet });
		if (!data?.n) return undefined;
		return { n: data.n, t: data.t, f: quiet ? () => {} : () => exprms_model.impression(id, data.n) };
	}, [id, exprms, statsigReady, quiet]);
}

